/**
 * BaZi Insights API URL configuration.
 * 
 * Production: REACT_APP_API_URL must be EMPTY so all API calls
 * use same-origin relative paths (e.g. /api/v1/...) which get
 * proxied through nginx (/api/ → backend).
 * 
 * Local dev: set REACT_APP_API_URL=http://localhost:8080
 * to point directly at the dev backend.
 */
export const API_URL = process.env.REACT_APP_API_URL || '';
